export const WARNING_LIMIT = 999999;

export const MESSAGE = {
  WARNING_LIMIT: 'You can consider the unlimited option.',
};
export const GRABPOINT = 'GRAB-POINT';
export const ACTION_AWARD_POINT_FORM_PRICE_PER_POINT_DEFAULT_VALUE = 0.0016;
export const ACTION_AWARD_POINT_FORM_CURRENCY_DEFAULT_VALUE = 'USD';
export const VARIABLE_NAME = 'variableName';
export const REQUIRE_VARIABLE = 'requireVariable';
export const DYNAMIC_TRACK = 'dynamicValuesToTrack';
export const CURRENCY_CONDITION_VARIABLE = 'var.payment.currency';
